// WARNING: This is cloaking simulation for demo purposes only. 
// Cloaking is against Google SEO guidelines and can result in a site being banned.

/**
 * Detects if the current device is mobile based on user agent
 * @returns {boolean} True if mobile device, false if desktop
 */
export const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Mobile device detection patterns
  const mobilePatterns = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
    /Mobile/i,
    /Tablet/i
  ];
  
  return mobilePatterns.some(pattern => pattern.test(userAgent));
};

/**
 * Gets the current device type for content switching
 * @returns {string} 'mobile' or 'desktop'
 */
export const getDeviceType = () => {
  return isMobileDevice() ? 'mobile' : 'desktop';
};

/**
 * Updates meta tags based on device type
 * @param {string} deviceType - 'mobile' or 'desktop'
 */
export const updateMetaTags = (deviceType) => {
  const title = document.getElementById('dynamic-title');
  const description = document.getElementById('dynamic-description');
  const keywords = document.getElementById('dynamic-keywords');
  
  if (deviceType === 'mobile') {
    // Mobile content - Optimized MrGamb + Casino keywords
    title.textContent = 'MrGamb 2025 Güncel Giriş | Casino Bonusları | MrGamb Medya';
    description.setAttribute('content', 'MrGamb 2025 güncel giriş adresi. Deneme bonusu veren siteler ve casino bonusları. MrGamb, MrGemb, MrGemp güncel adresleri.');
    keywords.setAttribute('content', 'mrgamb, deneme bonusu veren siteler 2025, free spin veren siteler, casino bonusları, mr gamb güncel giriş, bahiso güncel giriş, betbeymen güncel giriş, mrgemb güncel giriş, mrgemp güncel giriş, mrgamp güncel giriş, mrgamb medya, mrgamb giriş adresi, mrgamb yeni adres, mrgamb mobil giriş, betesbet güncel giriş');
  } else {
    // Desktop content - Optimized MrGamb + Casino keywords
    title.textContent = 'MrGamb 2025 Güncel Giriş | Casino Bonusları | MrGamb Medya';
    description.setAttribute('content', 'MrGamb 2025 güncel giriş adresi. Deneme bonusu veren siteler ve casino bonusları. MrGamb, MrGemb, MrGemp güncel adresleri.');
    keywords.setAttribute('content', 'mrgamb, deneme bonusu veren siteler 2025, free spin veren siteler, casino bonusları, mr gamb güncel giriş, bahiso güncel giriş, betbeymen güncel giriş, mrgemb güncel giriş, mrgemp güncel giriş, mrgamp güncel giriş, mrgamb medya, mrgamb giriş adresi, mrgamb yeni adres, mrgamb mobil giriş, betesbet güncel giriş');
  }
};
